{
  "CodeDeliveryFailureException": "Impossible de livrer le code. Veuillez réessayer plus tard.",
  "CodeMismatchException": "Le code que vous avez saisi n'est pas valide ; veuillez vérifier et réessayer.",
  "ExpiredCodeException": "Ce code est expiré.",
  "InvalidParemeterException": "Une erreur s'est produite. Veuillez réessayer ultérieurement.",
  "LimitExceededException": "Trop de tentatives. Veuillez réessayer plus tard",
  "NotAuthorizedException": "Votre email et/ou mot de passe sont incorrects.",
  "UserNotConfirmedException": "Le compte n'est pas confirmé.",
  "UserNotFoundException": "Votre email et/ou mot de passe sont incorrects.",
  "UsernameExistsException": "Le compte existe déjà.",
  "accountNotConfirmed": "Compte non confirmé",
  "anUnknownErrorOccurred": "Une erreur inconnue s'est produite",
  "codeSentToast": "Code envoyé.",
  "codeStringFieldLabel": "Code",
  "codeStringFieldPlaceholder": "Entrer le code",
  "confirmAccount": "Confirmer le compte",
  "confirmAccountButton": "Confirmer le compte",
  "confirmPasswordFieldLabel": "Confirmez le mot de passe",
  "confirmPasswordFieldPlaceholder": "*******",
  "contactUs": "Contactez-nous",
  "createAnAccount": "Créer un compte",
  "createUserAccount": "Créer un compte utilisateur",
  "credentialsSuccess": "Vous pouvez désormais vous connecter avec vos nouveaux identifiants.",
  "currentPasswordFieldLabel": "Mot de passe",
  "currentPasswordFieldPlaceholder": "*******",
  "emailFieldLabel": "E-mail",
  "emailFieldPlaceholder": "*******@exemple.com",
  "enterCodeFromYourEmail": "Saisissez le code de confirmation que nous avons envoyé à votre adresse e-mail.",
  "enterYourEmail": "Entrez votre adresse email",
  "needToConfirmYourAccount": "Besoin de confirmer votre compte ?",
  "newPasswordFieldLabel": "Mot de passe",
  "newPasswordFieldPlaceholder": "Entrez le mot de passe",
  "passwordResetCodeSentWithEmail": "Nous avons envoyé un code de réinitialisation de mot de passe à usage unique à {{email}} (assurez-vous de vérifier votre filtre anti-spam)",
  "passwordResetLinkTo": "Mot de passe oublié ?",
  "passwordResetTitle": "Réinitialisation du mot de passe",
  "signIn": "Se connecter",
  "signOut": "Se déconnecter",
  "youMustConfirmYourAccount": "Vous devez confirmer votre compte avant de pouvoir vous connecter."
}
